import React from 'react';
import PropTypes from 'prop-types';
import PayseraReactSpinner from '%app/js/common/components/PayseraReactSpinner';

function HallSpinner(props) {
    const { loading } = props;

    return loading && (<PayseraReactSpinner />);
}

HallSpinner.propTypes = {
    loading: PropTypes.bool.isRequired,
};

export default HallSpinner;
